<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__item"
  >
    <template #pic>
      <div class="label-pic is-green">
        <icon
          v-if="notification.percentComplete !== 100"
          data="@icon/milestoneIcon.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
        <icon
          v-else
          data="@icon/goal-complete.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <div class="notification-title-flex">
        <BaseSubHeading
          size="large"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="500"
        >
          <template v-if="notification.percentComplete !== 100"> Goal closed </template>
          <template v-else-if="notification.milestone && notification.percentComplete === 100">
            Milestone reached, <br />Goal achieved!
          </template>
          <template v-else-if="!notification.milestone && notification.percentComplete === 100">
            Roadmap Goal Achieved!
          </template>
        </BaseSubHeading>

        <BaseSubHeading
          size="small"
          color="monochrome-05"
          darkColor="monochrome-04"
          weight="500"
          class="project-setcion"
        >
          {{ notification.projectName }}
        </BaseSubHeading>
      </div>
    </template>
    <template #content>
      <div
        v-if="notification.milestone"
        className="notification__update-item__content"
      >
        <a
          :href="notification.mileStoneurl"
          class="link is-medium-500"
          target="_blank"
        >
          {{ notification.milestoneName }}
        </a>
        <BaseSubHeading
          size="medium"
          color="monochrome-07"
          weight="500"
          className="body-text-medium-500 milestone-date"
        >
          {{ notification.milestoneDate }}
        </BaseSubHeading>
      </div>
      <BaseSubHeading
        v-if="notification.content.totalItemsCount"
        size="medium"
        color="monochrome-07"
        weight="500"
        className="body-text-medium-500"
      >
        {{ notification.totalItemsCount }} Items, {{ notification.percentComplete }}% Done
      </BaseSubHeading>
      <BaseSubHeading
        v-if="notification.percentComplete !== 100 || notification.milestone"
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        class="curent-goal-text"
      >
        {{ notification.currentGoalContent }}
      </BaseSubHeading>
      <a
        v-else-if="notification.percentComplete === 100 && !notification.milestone"
        class="link is-medium-500 curent-goal-text"
        target="_blank"
        :href="notification.goalUrl"
      >
        {{ notification.currentGoalContent }}
      </a>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationGoal } from "@/models/Notification"

@Options({
  name: "GOAL_REACHED",
  components: {
    NotificationTemplate
  }
})
export default class GOAL_REACHED extends Vue {
  @Prop() readonly notification: NotificationGoal
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/utils/mixins/_flex";

.notification-title-flex {
  @include flex($justify: space-between, $align: center);

  gap: 4px;
}

.curent-goal-text {
  margin-top: var(--step2);
}

.notification__update-item__content {
  margin-top: var(--step2);
}
</style>
